// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"common_wrapper__1L0Ll","debugwindow":"common_debugwindow__1IdK7"};